<template>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as common from '@/utils/common';

export default {
  name: "aroBase",
  computed: {
    ...mapState("app", ["loginInfo"]),
    loginInfo: {
      get() {return this.$store.state.app.loginInfo;},
      set(val) {this.setLoginInfo(val);}
    },
    AroConst : {
      get() {return Const;}
    }
  },
  created() {
    let _this = this;

    //Aro Login Info
    _this.loginInfo = _this.$aroConfig.loginInfo;
  },
  mounted(){
    let _this = this;

    //init (release scroll lock)
    _this.$modalAfterTreat(false);
  },
  methods: {
    ...mapMutations("app", ["setLoginInfo"]),
    isLogined : function(){
      let _this = this;

      return !(_this.getMemberId() == null);
    },
    getMemberId : function(){
      let _this = this;

      if(_this.loginInfo
        && _this.loginInfo.memberId
        && _this.loginInfo.memberId.trim() != ""){
        return _this.loginInfo.memberId;
      }

      return null;
    },
    getMemberNmKr : function(){
      let _this = this;

      if(_this.loginInfo
        && _this.loginInfo.nm_kr
        && _this.loginInfo.nm_kr.trim() != ""){
        return _this.loginInfo.nm_kr;
      }

      return null;
    },
    getMemberType : function(){
      let _this = this;

      if(_this.loginInfo
        && _this.loginInfo.memberType
        && _this.loginInfo.memberType.trim() != ""){
        return _this.loginInfo.memberType;
      }

      return null;
    },
     getMemberTitle : function(){
      let _this = this;

      if(_this.loginInfo
        && _this.loginInfo.memberTitle
        && _this.loginInfo.memberTitle > 0){
        return _this.loginInfo.memberTitle;
      }

      return null;
    },

    /**
     * common function
     */
    $nvl(val, defVal){
      let dv = defVal || '-';
      if(typeof val === "number" && val == 0){
        return 0;
      }

      if(!val){
        return dv;
      }

      if(typeof val === "string" && val.trim() === ""){
        return dv;
      }

      return val;
    },

    //결제타입
    $getContentPaymentType(str) {
	    if (Const.VALUE_payment_type_credit_card == str) {
		    return "신용카드";
	    } else if (Const.VALUE_payment_type_account_transfer == str) {
		    return "자동 이체";
	    }
	    return "";
    },

    $getMemberIdKey : function(){
      let _this = this;

      if(_this.loginInfo
        && _this.loginInfo.memberId
        && _this.loginInfo.memberId.trim() !== ""){
        let ecode = _this.loginInfo.memberId;

        while (ecode.length < 16) {
          ecode += '0';
        }

        return ecode.trim();
      }
      return null;
    },

    imageError(img) {
      let _this = this;

      _this.$imageError(
        img
      );
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/AroBase.vue